import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { buttonLinkStyle } from "../../admin/StudySetup/Visits/Questionnaires/EditVisitQuestionnaire";
import { Col, Row } from "react-bootstrap";
import { Card, CardContent, CardMedia } from "@mui/material";
import { getSponsorByUserService } from "../../../services/sponsors";
import defaultSponsorImage from "../../../assets/admin/sponsors.png";

const SponsorsStudies = () => {
  const [load, setLoad] = useState(true);
  const [sponsorsData, setSponsorsData] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const userId = localStorage?.getItem("userId");

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token]);

  useEffect(() => {
    if (userId) {
      getAllSponsorForUser(userId);
    }
  }, [userId]);

  const getAllSponsorForUser = async (userId) => {
    setLoad(true);
    try {
      const res = await getSponsorByUserService(userId);
      if (res?.status == 200) {
        setLoad(false);
        if (res?.data?.result) {
          setSponsorsData(res?.data?.result);
        }
      }
    } catch (err) {
      setLoad(false);
      console.log(err.message);
    }
  };

  const getImageUrl = (imageUrl) => {
    let resImageUrl = imageUrl.split("wwwroot")[1];
    return `https://genesisapi.augursapps.com${resImageUrl}`;
  };

  return (
    <>
      {load ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <BeatLoader color="#3661eb" />
        </div>
      ) : (
        <div className="content-body">
          <p className="admin-link" style={{ fontWeight: "600" }}>
            <button style={buttonLinkStyle}>Sponsors</button>
          </p>
          <div style={{ marginTop: "30px" }}>
            <Row xl={6} lg={6} md={6} sm={12} xs={12}>
              {sponsorsData &&
                sponsorsData?.map((item, index) => (
                  <Col
                    xl={4}
                    lg={2}
                    md={6}
                    sm={12}
                    xs={12}
                    key={index}
                    style={{ marginBottom: "20px" }}
                  >
                    <Card
                      sx={{
                        maxWidth: 200,
                        cursor: "pointer",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                      onClick={(e) => {
                        navigate("/user-studies", {
                          state: {
                            id: item?.id,
                          },
                        });
                      }}
                    >
                      <CardMedia
                        component="img"
                        alt="card-image"
                        className="fluid-image"
                        sx={{
                          height: "110px",
                          width: "115px",
                          objectFit: "cover",
                          margin: "auto",
                          padding: "10px",
                          borderRadius: "50%",
                        }}
                        image={getImageUrl(item?.imageUrl)}
                        onError={(e) => (e.target.src = defaultSponsorImage)}
                      />
                      <CardContent>
                        <button
                          style={buttonLinkStyle}
                          onClick={(e) => {
                            navigate("/user-studies", {
                              state: {
                                id: item?.id,
                              },
                            });
                          }}
                          gutterBottom
                          variant="h5"
                          component="div"
                        >
                          {item?.sponsorName}
                        </button>
                      </CardContent>
                    </Card>
                  </Col>
                ))}
            </Row>
          </div>
        </div>
      )}
    </>
  );
};

export default SponsorsStudies;
